import { Input, Password, Inputmuliline } from "./Input";
import RadioGroup from "./RadioGroup";
import Select from "./Select";
import Checkbox from "./CheckBox";
import ConfirmationDialog from "./ConfirmDialog";
const Controls = {
  Inputmuliline,
  Input,
  Password,
  RadioGroup,
  Select,
  Checkbox,
  ConfirmationDialog,
};

export default Controls;
